import { Component, OnInit, inject } from '@angular/core';
import { ChildrenOutletContexts } from '@angular/router';
import { slider } from '@helpers/animations.helper';
import { CommonService } from '@services/common.service';

@Component({
  selector: 'market-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [slider],
})
export class AppComponent implements OnInit {
  title = 'nutri-market';
  contexts = inject(ChildrenOutletContexts);
  loading = inject(CommonService).loading;

  ngOnInit(): void {}

  getRouteAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.[
      'animation'
    ];
  }
}
